/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.StockAnalysis.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbsolutePerformances
 */
export interface AbsolutePerformances {
    /**
     * 
     * @type {string}
     * @memberof AbsolutePerformances
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsolutePerformances
     */
    'CurrencyId'?: string;
    /**
     * 
     * @type {Data}
     * @memberof AbsolutePerformances
     */
    'data'?: Data;
}
/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface CompareReplay
 */
export interface CompareReplay {
    /**
     * 
     * @type {Array<CompareRowInfo>}
     * @memberof CompareReplay
     */
    'rows'?: Array<CompareRowInfo>;
    /**
     * 
     * @type {string}
     * @memberof CompareReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface CompareRowInfo
 */
export interface CompareRowInfo {
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'uniqueCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'alternativeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompareRowInfo
     */
    'countryCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'fk'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'pddd'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'sales'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'ebitda'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'pgrowth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompareRowInfo
     */
    'dividend'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CurrenciesEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type CurrenciesEnum = typeof CurrenciesEnum[keyof typeof CurrenciesEnum];


/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'weekly'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'monthly'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'annual'?: number;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'ytd'?: number;
}
/**
 * 
 * @export
 * @interface DownReplay
 */
export interface DownReplay {
    /**
     * 
     * @type {string}
     * @memberof DownReplay
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {Array<RatioCategoryInfo>}
     * @memberof FetchReplay
     */
    'categories'?: Array<RatioCategoryInfo>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FieldofActivityReplay
 */
export interface FieldofActivityReplay {
    /**
     * 
     * @type {string}
     * @memberof FieldofActivityReplay
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldofActivityReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FinancialCaption
 */
export interface FinancialCaption {
    /**
     * 
     * @type {string}
     * @memberof FinancialCaption
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FinancialCaption
     */
    'isGroupLine'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FinancialCaption
     */
    'isHeadline'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FinancialCaption
     */
    'level'?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialCaption
     */
    'style'?: number;
}
/**
 * 
 * @export
 * @interface FinancialValue
 */
export interface FinancialValue {
    /**
     * 
     * @type {number}
     * @memberof FinancialValue
     */
    'quarter'?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialValue
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface FinancialsInfo
 */
export interface FinancialsInfo {
    /**
     * 
     * @type {FinancialCaption}
     * @memberof FinancialsInfo
     */
    'caption'?: FinancialCaption;
    /**
     * 
     * @type {Array<FinancialValue>}
     * @memberof FinancialsInfo
     */
    'values'?: Array<FinancialValue>;
}
/**
 * 
 * @export
 * @interface FinancialsReplay
 */
export interface FinancialsReplay {
    /**
     * 
     * @type {Array<FinancialsInfo>}
     * @memberof FinancialsReplay
     */
    'items'?: Array<FinancialsInfo>;
    /**
     * 
     * @type {string}
     * @memberof FinancialsReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface IndicatorInfo
 */
export interface IndicatorInfo {
    /**
     * 
     * @type {string}
     * @memberof IndicatorInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof IndicatorInfo
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndicatorInfo
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface IndicatorReplay
 */
export interface IndicatorReplay {
    /**
     * 
     * @type {Array<IndicatorInfo>}
     * @memberof IndicatorReplay
     */
    'items'?: Array<IndicatorInfo>;
    /**
     * 
     * @type {string}
     * @memberof IndicatorReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ListReplay
 */
export interface ListReplay {
    /**
     * 
     * @type {Array<ReportCategoryInfo>}
     * @memberof ListReplay
     */
    'categories'?: Array<ReportCategoryInfo>;
    /**
     * 
     * @type {string}
     * @memberof ListReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PartnerInfo
 */
export interface PartnerInfo {
    /**
     * 
     * @type {string}
     * @memberof PartnerInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerInfo
     */
    'Percent'?: number;
}
/**
 * 
 * @export
 * @interface PartnershipReplay
 */
export interface PartnershipReplay {
    /**
     * 
     * @type {Array<PartnerInfo>}
     * @memberof PartnershipReplay
     */
    'partners'?: Array<PartnerInfo>;
    /**
     * 
     * @type {string}
     * @memberof PartnershipReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PriceChartReplay
 */
export interface PriceChartReplay {
    /**
     * 
     * @type {string}
     * @memberof PriceChartReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PricePerformanceAbsoluteReplay
 */
export interface PricePerformanceAbsoluteReplay {
    /**
     * 
     * @type {Array<AbsolutePerformances>}
     * @memberof PricePerformanceAbsoluteReplay
     */
    'absolutes'?: Array<AbsolutePerformances>;
    /**
     * 
     * @type {string}
     * @memberof PricePerformanceAbsoluteReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PricePerformanceRelativeReplay
 */
export interface PricePerformanceRelativeReplay {
    /**
     * 
     * @type {Array<RelativePerformances>}
     * @memberof PricePerformanceRelativeReplay
     */
    'relativePerformances'?: Array<RelativePerformances>;
    /**
     * 
     * @type {string}
     * @memberof PricePerformanceRelativeReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface RatioCategoryInfo
 */
export interface RatioCategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof RatioCategoryInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<RatioRowInfo>}
     * @memberof RatioCategoryInfo
     */
    'rows'?: Array<RatioRowInfo>;
    /**
     * 
     * @type {number}
     * @memberof RatioCategoryInfo
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface RatioRowInfo
 */
export interface RatioRowInfo {
    /**
     * 
     * @type {string}
     * @memberof RatioRowInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RatioRowInfo
     */
    'Columns'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RatioRowInfo
     */
    'Values'?: Array<number>;
}
/**
 * 
 * @export
 * @interface RelativePerformances
 */
export interface RelativePerformances {
    /**
     * 
     * @type {string}
     * @memberof RelativePerformances
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelativePerformances
     */
    'constituententityId'?: string;
    /**
     * 
     * @type {Data}
     * @memberof RelativePerformances
     */
    'data'?: Data;
}
/**
 * 
 * @export
 * @interface ReportCategoryInfo
 */
export interface ReportCategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof ReportCategoryInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ReportData>}
     * @memberof ReportCategoryInfo
     */
    'items'?: Array<ReportData>;
}
/**
 * 
 * @export
 * @interface ReportData
 */
export interface ReportData {
    /**
     * 
     * @type {string}
     * @memberof ReportData
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportData
     */
    'languageId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportData
     */
    'quarter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportData
     */
    'template'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportData
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportData
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}
/**
 * 
 * @export
 * @interface SubsidiaryInfo
 */
export interface SubsidiaryInfo {
    /**
     * 
     * @type {string}
     * @memberof SubsidiaryInfo
     */
    'subsidiaryType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubsidiaryInfo
     */
    'subsidiaryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubsidiaryInfo
     */
    'PercentOwnership'?: number;
}
/**
 * 
 * @export
 * @interface SubsidiaryReplay
 */
export interface SubsidiaryReplay {
    /**
     * 
     * @type {Array<SubsidiaryInfo>}
     * @memberof SubsidiaryReplay
     */
    'subsidiars'?: Array<SubsidiaryInfo>;
    /**
     * 
     * @type {string}
     * @memberof SubsidiaryReplay
     */
    'error'?: string;
}

/**
 * CompareServiceApi - axios parameter creator
 * @export
 */
export const CompareServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {Array<string>} [entityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareCompareGet: async (identityToken: string, culture?: string, entityIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('compareCompareGet', 'identityToken', identityToken)
            const localVarPath = `/compare/compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompareServiceApi - functional programming interface
 * @export
 */
export const CompareServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompareServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {Array<string>} [entityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareCompareGet(identityToken: string, culture?: string, entityIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompareReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareCompareGet(identityToken, culture, entityIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompareServiceApi - factory interface
 * @export
 */
export const CompareServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompareServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {Array<string>} [entityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareCompareGet(identityToken: string, culture?: string, entityIds?: Array<string>, options?: any): AxiosPromise<CompareReplay> {
            return localVarFp.compareCompareGet(identityToken, culture, entityIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompareServiceApi - object-oriented interface
 * @export
 * @class CompareServiceApi
 * @extends {BaseAPI}
 */
export class CompareServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {Array<string>} [entityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompareServiceApi
     */
    public compareCompareGet(identityToken: string, culture?: string, entityIds?: Array<string>, options?: AxiosRequestConfig) {
        return CompareServiceApiFp(this.configuration).compareCompareGet(identityToken, culture, entityIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadServiceApi - axios parameter creator
 * @export
 */
export const DownloadServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [filename] 
         * @param {string} [reportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisDownloadGet: async (identityToken: string, entityId?: string, filename?: string, reportId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisDownloadGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }

            if (reportId !== undefined) {
                localVarQueryParameter['reportId'] = reportId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadServiceApi - functional programming interface
 * @export
 */
export const DownloadServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [filename] 
         * @param {string} [reportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisDownloadGet(identityToken: string, entityId?: string, filename?: string, reportId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisDownloadGet(identityToken, entityId, filename, reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DownloadServiceApi - factory interface
 * @export
 */
export const DownloadServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [filename] 
         * @param {string} [reportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisDownloadGet(identityToken: string, entityId?: string, filename?: string, reportId?: string, options?: any): AxiosPromise<DownReplay> {
            return localVarFp.stockanalysisDownloadGet(identityToken, entityId, filename, reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadServiceApi - object-oriented interface
 * @export
 * @class DownloadServiceApi
 * @extends {BaseAPI}
 */
export class DownloadServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [filename] 
     * @param {string} [reportId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadServiceApi
     */
    public stockanalysisDownloadGet(identityToken: string, entityId?: string, filename?: string, reportId?: string, options?: AxiosRequestConfig) {
        return DownloadServiceApiFp(this.configuration).stockanalysisDownloadGet(identityToken, entityId, filename, reportId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialsServiceApi - axios parameter creator
 * @export
 */
export const FinancialsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisFinancialsGet: async (identityToken: string, culture?: string, entityId?: string, currency?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisFinancialsGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/financials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialsServiceApi - functional programming interface
 * @export
 */
export const FinancialsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisFinancialsGet(identityToken: string, culture?: string, entityId?: string, currency?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisFinancialsGet(identityToken, culture, entityId, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FinancialsServiceApi - factory interface
 * @export
 */
export const FinancialsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialsServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisFinancialsGet(identityToken: string, culture?: string, entityId?: string, currency?: number, options?: any): AxiosPromise<FinancialsReplay> {
            return localVarFp.stockanalysisFinancialsGet(identityToken, culture, entityId, currency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialsServiceApi - object-oriented interface
 * @export
 * @class FinancialsServiceApi
 * @extends {BaseAPI}
 */
export class FinancialsServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {number} [currency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsServiceApi
     */
    public stockanalysisFinancialsGet(identityToken: string, culture?: string, entityId?: string, currency?: number, options?: AxiosRequestConfig) {
        return FinancialsServiceApiFp(this.configuration).stockanalysisFinancialsGet(identityToken, culture, entityId, currency, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnershipServiceApi - axios parameter creator
 * @export
 */
export const PartnershipServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnershipPartnershipListGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('partnershipPartnershipListGet', 'identityToken', identityToken)
            const localVarPath = `/Partnership/PartnershipList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnershipServiceApi - functional programming interface
 * @export
 */
export const PartnershipServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnershipServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnershipPartnershipListGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnershipReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnershipPartnershipListGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartnershipServiceApi - factory interface
 * @export
 */
export const PartnershipServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnershipServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnershipPartnershipListGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<PartnershipReplay> {
            return localVarFp.partnershipPartnershipListGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnershipServiceApi - object-oriented interface
 * @export
 * @class PartnershipServiceApi
 * @extends {BaseAPI}
 */
export class PartnershipServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnershipServiceApi
     */
    public partnershipPartnershipListGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return PartnershipServiceApiFp(this.configuration).partnershipPartnershipListGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RatioServiceApi - axios parameter creator
 * @export
 */
export const RatioServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisRatioFetchGet: async (identityToken: string, culture?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisRatioFetchGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/ratio-fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatioServiceApi - functional programming interface
 * @export
 */
export const RatioServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatioServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisRatioFetchGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisRatioFetchGet(identityToken, culture, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RatioServiceApi - factory interface
 * @export
 */
export const RatioServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatioServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisRatioFetchGet(identityToken: string, culture?: string, entityId?: string, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.stockanalysisRatioFetchGet(identityToken, culture, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RatioServiceApi - object-oriented interface
 * @export
 * @class RatioServiceApi
 * @extends {BaseAPI}
 */
export class RatioServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatioServiceApi
     */
    public stockanalysisRatioFetchGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig) {
        return RatioServiceApiFp(this.configuration).stockanalysisRatioFetchGet(identityToken, culture, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportServiceApi - axios parameter creator
 * @export
 */
export const ReportServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListGet: async (identityToken: string, culture?: string, entityId?: string, categoryId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('reportListGet', 'identityToken', identityToken)
            const localVarPath = `/report/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportServiceApi - functional programming interface
 * @export
 */
export const ReportServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportListGet(identityToken: string, culture?: string, entityId?: string, categoryId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportListGet(identityToken, culture, entityId, categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportServiceApi - factory interface
 * @export
 */
export const ReportServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportListGet(identityToken: string, culture?: string, entityId?: string, categoryId?: number, options?: any): AxiosPromise<ListReplay> {
            return localVarFp.reportListGet(identityToken, culture, entityId, categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportServiceApi - object-oriented interface
 * @export
 * @class ReportServiceApi
 * @extends {BaseAPI}
 */
export class ReportServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {number} [categoryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceApi
     */
    public reportListGet(identityToken: string, culture?: string, entityId?: string, categoryId?: number, options?: AxiosRequestConfig) {
        return ReportServiceApiFp(this.configuration).reportListGet(identityToken, culture, entityId, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubsidiaryServiceApi - axios parameter creator
 * @export
 */
export const SubsidiaryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subsidiarySubsidiaryListGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('subsidiarySubsidiaryListGet', 'identityToken', identityToken)
            const localVarPath = `/Subsidiary/SubsidiaryList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubsidiaryServiceApi - functional programming interface
 * @export
 */
export const SubsidiaryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubsidiaryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subsidiarySubsidiaryListGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubsidiaryReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subsidiarySubsidiaryListGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubsidiaryServiceApi - factory interface
 * @export
 */
export const SubsidiaryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubsidiaryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subsidiarySubsidiaryListGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<SubsidiaryReplay> {
            return localVarFp.subsidiarySubsidiaryListGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubsidiaryServiceApi - object-oriented interface
 * @export
 * @class SubsidiaryServiceApi
 * @extends {BaseAPI}
 */
export class SubsidiaryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsidiaryServiceApi
     */
    public subsidiarySubsidiaryListGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return SubsidiaryServiceApiFp(this.configuration).subsidiarySubsidiaryListGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SummaryServiceApi - axios parameter creator
 * @export
 */
export const SummaryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisFieldofactivityGet: async (identityToken: string, culture?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisFieldofactivityGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/fieldofactivity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisIndicatorsGet: async (identityToken: string, culture?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisIndicatorsGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/indicators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPricechartGet: async (identityToken: string, culture?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisPricechartGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/pricechart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CurrenciesEnum} [currencyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPriceperfomanceAbsoluteGet: async (identityToken: string, currencyId?: CurrenciesEnum, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisPriceperfomanceAbsoluteGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/priceperfomance-absolute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currencyId !== undefined) {
                localVarQueryParameter['currencyId'] = currencyId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [constituententityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPriceperfomanceRelativeGet: async (identityToken: string, constituententityId?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('stockanalysisPriceperfomanceRelativeGet', 'identityToken', identityToken)
            const localVarPath = `/stockanalysis/priceperfomance-relative`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (constituententityId !== undefined) {
                localVarQueryParameter['constituententityId'] = constituententityId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryServiceApi - functional programming interface
 * @export
 */
export const SummaryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SummaryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisFieldofactivityGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldofActivityReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisFieldofactivityGet(identityToken, culture, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisIndicatorsGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndicatorReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisIndicatorsGet(identityToken, culture, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisPricechartGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceChartReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisPricechartGet(identityToken, culture, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CurrenciesEnum} [currencyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisPriceperfomanceAbsoluteGet(identityToken: string, currencyId?: CurrenciesEnum, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricePerformanceAbsoluteReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisPriceperfomanceAbsoluteGet(identityToken, currencyId, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [constituententityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stockanalysisPriceperfomanceRelativeGet(identityToken: string, constituententityId?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricePerformanceRelativeReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stockanalysisPriceperfomanceRelativeGet(identityToken, constituententityId, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SummaryServiceApi - factory interface
 * @export
 */
export const SummaryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SummaryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisFieldofactivityGet(identityToken: string, culture?: string, entityId?: string, options?: any): AxiosPromise<FieldofActivityReplay> {
            return localVarFp.stockanalysisFieldofactivityGet(identityToken, culture, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisIndicatorsGet(identityToken: string, culture?: string, entityId?: string, options?: any): AxiosPromise<IndicatorReplay> {
            return localVarFp.stockanalysisIndicatorsGet(identityToken, culture, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPricechartGet(identityToken: string, culture?: string, entityId?: string, options?: any): AxiosPromise<PriceChartReplay> {
            return localVarFp.stockanalysisPricechartGet(identityToken, culture, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CurrenciesEnum} [currencyId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPriceperfomanceAbsoluteGet(identityToken: string, currencyId?: CurrenciesEnum, entityId?: string, options?: any): AxiosPromise<PricePerformanceAbsoluteReplay> {
            return localVarFp.stockanalysisPriceperfomanceAbsoluteGet(identityToken, currencyId, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [constituententityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stockanalysisPriceperfomanceRelativeGet(identityToken: string, constituententityId?: string, entityId?: string, options?: any): AxiosPromise<PricePerformanceRelativeReplay> {
            return localVarFp.stockanalysisPriceperfomanceRelativeGet(identityToken, constituententityId, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SummaryServiceApi - object-oriented interface
 * @export
 * @class SummaryServiceApi
 * @extends {BaseAPI}
 */
export class SummaryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryServiceApi
     */
    public stockanalysisFieldofactivityGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig) {
        return SummaryServiceApiFp(this.configuration).stockanalysisFieldofactivityGet(identityToken, culture, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryServiceApi
     */
    public stockanalysisIndicatorsGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig) {
        return SummaryServiceApiFp(this.configuration).stockanalysisIndicatorsGet(identityToken, culture, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryServiceApi
     */
    public stockanalysisPricechartGet(identityToken: string, culture?: string, entityId?: string, options?: AxiosRequestConfig) {
        return SummaryServiceApiFp(this.configuration).stockanalysisPricechartGet(identityToken, culture, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {CurrenciesEnum} [currencyId] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryServiceApi
     */
    public stockanalysisPriceperfomanceAbsoluteGet(identityToken: string, currencyId?: CurrenciesEnum, entityId?: string, options?: AxiosRequestConfig) {
        return SummaryServiceApiFp(this.configuration).stockanalysisPriceperfomanceAbsoluteGet(identityToken, currencyId, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [constituententityId] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryServiceApi
     */
    public stockanalysisPriceperfomanceRelativeGet(identityToken: string, constituententityId?: string, entityId?: string, options?: AxiosRequestConfig) {
        return SummaryServiceApiFp(this.configuration).stockanalysisPriceperfomanceRelativeGet(identityToken, constituententityId, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



